import style from './style.module.scss';
import {Typography} from 'components/Typography';
import {Box} from 'components/Grid';
import Link from 'components/Link';
import classNames from 'classnames';
import {WARNING_TEXT_PART_ONE, WARNING_TEXT_PART_TWO} from 'modules/footer/constants';

interface IFooterWarningProps {
    className?: string;
}

export const FooterWarning = ({className}: IFooterWarningProps) => {
    return (
        <div className={classNames(style.footerWarning, className)}>
            <Box>
                <div className={style.content}>
                    <Typography element={'div'} color={'gray60'} variant={'label-12-r'}>
                        {WARNING_TEXT_PART_ONE}
                        <Link className={style.linkWrap} href={'/'}>
                            <Typography
                                children={' https://www.simplewine.ru/ '}
                                className={style.link}
                                variant={'label-12-r'}
                                color={'gray60'}
                            />
                        </Link>
                        {WARNING_TEXT_PART_TWO}
                    </Typography>
                </div>
            </Box>
        </div>
    );
};
